import {
  SET_DOCUMENT_MANAGEMENT_TABLE_EXCLUDED_COLS,
} from './actions';

export default function(state = { documentManagementTableExcludedCols: {}}, action) {
  switch (action.type) {
    case SET_DOCUMENT_MANAGEMENT_TABLE_EXCLUDED_COLS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/document_management/index.js